import { getCouncilConfig, isLondonCouncil } from '../councils';
import { isSourceOnlyPlanningRecord } from './londonSharedDelivery';

const emptyArrays = new Set(['tags', 'tag_details', 'interest_signals', 'group_members', 'related_applications']);
const emptyObjects = new Set(['ai_match_data', 'parsed']);
const derived = new Set(['ai_summary', 'category', 'application_type', 'scale_rating', 'impact',
  'impact_rating', 'interesting', 'interest_confidence', 'interest_reason', 'match_ref',
  'group_id', 'group_summary', 'group_category', 'group_scale_rating', 'group_match_ref',
  'group_name', 'classification_method', 'site_postcode', 'site_outcode']);

export function sanitizePublicPlanningRecord(record: Record<string, unknown>): Record<string, unknown> {
  const council = getCouncilConfig(String(record.source_council || ''));
  if (council?.releaseStage !== 'official_records' && record.release_stage !== 'official_records' &&
      !(isLondonCouncil(String(record.source_council || '')) && isSourceOnlyPlanningRecord(record))) return record;
  const result: Record<string, unknown> = { ...record, release_stage: 'official_records',
    ...(isLondonCouncil(String(record.source_council || '')) ? { source_record_only:true } : {}) };
  for (const key of Object.keys(result)) {
    if (emptyArrays.has(key)) result[key] = [];
    else if (emptyObjects.has(key)) result[key] = {};
    else if (derived.has(key) || /^(ai_|group_|interest_)/.test(key)) result[key] = null;
    else if (key === 'has_published_article') result[key] = false;
  }
  return result;
}
